import { Filter, SavedSearch } from './types';

export const CONTEXT_PARAMS = ['view', 'tab', 'source', 'idents'];

export const OPERATOR_MAP: Record<string, string> = {
  eq: '=',
  neq: '≠',
  gt: '>',
  gte: '≥',
  lt: '<',
  lte: '≤',
  in: '∈',
  nin: '∉',
  contains: 'contains',
  startswith: 'starts with',
  endswith: 'ends with',
};

export const isValidFilterValue = (value: any): boolean => {
  return (
    value !== undefined && value !== null && value !== '' && !(Array.isArray(value) && value.length === 0)
  );
};

export const filterColumnFilters = (filters: Filter[]): Filter[] => {
  return filters.filter((f: Filter) => !CONTEXT_PARAMS.includes(f.name) && isValidFilterValue(f.value));
};

export const determineSearchType = (filter: any): SavedSearch['type'] => {
  if (filter.type) return filter.type;

  const hasColumns = filter.columnVisibilityModel || filter.columnOrder;
  const hasFilters = filter.filters && filter.filters.length > 0;
  const hasSearchQuery = filter.searchQuery && filter.searchQuery.trim() !== '';

  if (hasColumns && hasFilters) return 'complete';
  if (hasColumns) return 'columns';
  if (hasFilters) return 'filter';
  if (hasSearchQuery) return 'search';
  return 'filter';
};

export const storeTemporaryData = (searchId: string, data: any, isComplete: boolean) => {
  const tempKey = `_temp_load${isComplete ? 'Complete' : 'Columns'}_${searchId}`;
  localStorage.setItem(tempKey, JSON.stringify(data));
};

export const formatDate = (timestamp: string) => {
  return new Date(timestamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getEmptyMessage = (tab: 'filters' | 'searches' | 'columns' | 'scores'): string => {
  const messages = {
    filters: 'You don`t have any saved filters.',
    searches: 'You don`t have any saved searches.',
    columns: 'You don`t have any saved columns selection.',
    scores: 'You don`t have any saved scores.',
  };
  return messages[tab];
};

export const getTabLabel = (tab: 'filters' | 'searches' | 'columns' | 'scores'): string => {
  const labels = {
    filters: 'Saved filters',
    searches: 'Saved searches',
    columns: 'Saved columns',
    scores: 'Saved scores',
  };
  return labels[tab];
};
